import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import { HOSTUrls } from "./services/config/host.config";
import {
  Button,
  Form,
  FormItem,
  Card,
  Input,
  Upload,
  DatePicker,
  Message,
  Dialog,
  Select,
  Option,
  Image,
  InputNumber,
  Alert,
  Tag,
  Popover,
  Divider,
  MessageBox,
} from "element-ui";
import "@assets/css/index.scss";

Vue.config.productionTip = false;
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Card);
Vue.use(Input);
Vue.use(Upload);
Vue.use(DatePicker);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Image);
Vue.use(InputNumber);
Vue.use(Alert);
Vue.use(Tag);
Vue.use(Popover);
Vue.use(Divider);
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
let Env = process.env.VUE_APP_CURRENTMODE || "test";

// 1. ----- 项目动态域名处理 start -------
// FIXME 本地修改环境变量直接替换为 dev / test / prod
// Env = 'test';

if (window.location.host.includes("link.hortorgames.com")) {
  Env = "prod";
}
console.log("processEnv: ", process.env.VUE_APP_CURRENTMODE || undefined);
console.log("--- Env ---", Env);

// host赋值
for (const hostName in HOSTUrls) {
  window[hostName] = HOSTUrls[hostName][Env];
  Vue.prototype[hostName] = HOSTUrls[hostName][Env];
}
// ----- 项目动态域名处理 end -------

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "HortorGames";
  next();
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

